import React, { useEffect } from 'react';
import { useState } from "react";

type DeviceContextType = any;

const CommonContext = React.createContext<DeviceContextType>(true);

const CommonProvider = ({ children }: any) => {
    const [isDesktop, setIsDesktop] = useState<DeviceContextType>(false);
    const [isMobile, setIsMobile] = useState<DeviceContextType>(false);
    

    useEffect(() => {
        const media = window.matchMedia('(min-width: 993px)');
        const listener = () => setIsDesktop(media.matches);
        listener();
        window.addEventListener('resize', listener);
    
        return () => window.removeEventListener('resize', listener);
    }, [isDesktop, isMobile]);

    useEffect(() => {
        const media = window.matchMedia('(max-width: 640px)');
        const listener = () => setIsMobile(media.matches);
        listener();
        window.addEventListener('resize', listener);
    
        return () => window.removeEventListener('resize', listener);
    }, [isMobile, isDesktop]);

    
    return (
        <CommonContext.Provider value={ {isDesktop, isMobile} }>{children}</CommonContext.Provider>
    );
}
export { CommonProvider, CommonContext };